
function install (Vue) {
  let mainStore = null
  const hyRtcSdk = {
    /**
     * 存储基座sdk操作
     */
    initSocket (res) {
      mainStore = res
    },
    obtainAllClientIdList (obj) {
      // obj === null 放回全部设备
      // obj.audioType === true 返回对接中的设备
      // obj.videoType === true 返回调用画面的设备
      // obj.appointed 返回指定类型的设备
      return mainStore.getters.obtainAllClientIdList(obj)
    },
    /* 连接状态 */
    connectionStatus () {
      return mainStore.getters.connectionStatus()
    },
    /* =================================== 获取消息（getters） =================================== */
      clientIdFn () {
        return mainStore.getters.clientIdFn()
      },
      consumerPaused () {
        return mainStore.getters.consumerPaused()
      },
      consumerResume () {
        return mainStore.getters.consumerResume()
      },
      videoInputListFn () {
        return mainStore.getters.videoInputListFn()
      },

      getRoom (roomId) {
        return mainStore.getters.getRoom(roomId)
      },

      // 房间信息
      roomInformationFn () {
        return mainStore.getters.roomInformationFn()
      },
      // 获取麦克风列表
      audioInputListFn () {
        return mainStore.getters.audioInputListFn()
      },
      // 视频房间信息
      videoRoomInformationFn () {
        return mainStore.getters.videoRoomInformationFn()
      },
      // 获取当前本地视频流
      getLocalVideoStream (obj) {
        return mainStore.getters.getLocalVideoStream(obj)
      },
      // 获取当前本地音频流
      getLocalAudioStream (obj) {
        return mainStore.getters.getLocalAudioStream(obj)
      },
    /* =================================== 房间操作 =================================== */
      /* 发送房间消息 */
      sendRoomMessage (method, roomId, clientId) {
        mainStore.commit('sendRoomMessage', {
          method, roomId, clientId
        })
      },
      /* 加入失败 */
      joinFailedFn (type) {
        mainStore.commit('joinFailedFn', type)
      },
      /* 退出房间 */
      exitRoomFn (roomId) {
        mainStore.commit('exitRoomFn', roomId)
      },
    /* =================================== 加入房间操作 =================================== */
      /* 发起对讲 */
      intercom (obj, failCallback, successCallback) {
        mainStore.commit('intercom', {
          obj,
          failCallback,
          successCallback
        })
      },
      /* 语音通话 (可以进行其他操作) */
      intercomcall (obj, failCallback, successCallback) {
        mainStore.commit('intercomcall', {
          obj,
          failCallback,
          successCallback
        })
      },
      /* 发起监控 */
      monitor (obj, failCallback, successCallback) {
        mainStore.commit('monitor', {
          obj,
          failCallback,
          successCallback
        })
      },
      /* 发起监控 */
      videoMeetingIn (obj, failCallback, successCallback) {
        mainStore.commit('videoMeetingIn', {
          obj,
          failCallback,
          successCallback
        })
      },
      /* 视频录制 */
      recordVideo (obj, failCallback, successCallback) {
        mainStore.commit('recordVideo', {
          obj,
          failCallback,
          successCallback
        })
      },
      /* 加入频道 */
      channelInFn (obj, failCallback, successCallback) {
        mainStore.commit('channelInFn', {
          obj,
          failCallback,
          successCallback
        })
      },
      setVideoInput (videoStream) {
        mainStore.commit('setVideoInput', videoStream)
      },
      setAudioInput (audioStream) {
        mainStore.commit('setAudioInput', audioStream)
      },
      /* =================================== 加入房间后的操作 =================================== */
      // 在生产时更换视频输入源
      replaceVideoDevice (videoInput, obj) {
        // const obj = {
        //   facingMode 前摄像 user 还是 后摄像 environment
        //   roomId：有房间id，就是针对房间id设置，没有就是全局
        //   successCallback 成功回调
        //   failCallback 失败回调
        // }
        mainStore.commit('replaceVideoDevice', {
          videoInput,
          ...obj
        })
      },

      // 在生产时更换视频输入轨道
      replaceVideoTrack (track, obj) {
        // const obj = {
        //   roomId：有房间id，就是针对房间id设置，没有就是全局
        //   successCallback 成功回调
        //   failCallback 失败回调
        // }
        mainStore.commit('replaceVideoTrack', {
          track,
          ...obj
        })
      },

      // 在生产时更换音频输入源
      replaceAudioDevice (audioInput, obj) {
        // const obj = {
        //   roomId：有房间id，就是针对房间id设置，没有就是全局
        //   successCallback 成功回调
        //   failCallback 失败回调
        // }
        mainStore.commit('replaceAudioDevice', {
          audioInput,
          ...obj
        })
      },

      // 在生产时更换音频输入轨道
      replaceAudioTrack (track, obj) {
        // const obj = {
        //   roomId：有房间id，就是针对房间id设置，没有就是全局
        //   successCallback 成功回调
        //   failCallback 失败回调
        // }
        mainStore.commit('replaceAudioTrack', {
          track,
          ...obj
        })
      },

      /*中控操作*/
      notificationDeviceControl (parameter) {
        mainStore.commit('notificationDeviceControl', parameter)
      },
      /**
       * 获取话语权
       */
      audioConsumerResume (obj) {
        mainStore.commit('audioConsumerResume', obj)
      },
      videoConsumerResume (obj) {
        mainStore.commit('videoConsumerResume', obj)
      },
      /**
       * 释放话语权
       */
      audioConsumerPaused (obj) {
        mainStore.commit('audioConsumerPaused', obj)
      },
      videoConsumerPaused (obj) {
        mainStore.commit('videoConsumerPaused', obj)
      },
    /**
     * 获取屏幕流
     * @param { video: true, audio: true }
     */
      getDisplayMedia (param) {
         // const obj = {
          //   params：{ video: true, audio: true }
          //   successCallback 成功回调
          //   failCallback 失败回调
          // }
         return new Promise((resolve, reject) => {
            mainStore.commit('getDisplayMedia', {
              param,
              successCallback: (stream) => {
                resolve(stream)
              },
              failCallback: (e) => {
                reject(e)
              },
            })
         })
      },
    /**
     * 传入一个流，拆分成音频流和视频流
     * @param stream
     */
      handlerDisplayMediaStream (stream) {
        return new Promise((resolve, reject) => {
          mainStore.commit('handlerDisplayMediaStream', {
            stream,
            successCallback: (res) => {
              resolve(res)
            },
            failCallback: (e) => {
              reject(e)
            },
          })
        })
      },
    /**
     * 在生产时更换视频输入源
     */
    replaceVideoStream (videoStream, roomId) {
      mainStore.commit('replaceVideoStream', {stream: videoStream, roomId})
    },
    replaceAudioStream (audioStream, roomId) {
      mainStore.commit('replaceAudioStream', {stream: audioStream, roomId})
    },

    disableMic (roomId) {
      mainStore.commit('disableMic', roomId)
    },
    disableWebcam (roomId) {
      mainStore.commit('disableWebcam', roomId)
    },

  }
  Vue.prototype.$sdk = Object.assign({}, hyRtcSdk)
}
export default install
